var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-account",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22.857,
    viewBox: "0 0 20 22.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M17,7.333A5.385,5.385,0,1,1,11.615,2,5.359,5.359,0,0,1,17,7.333Z",
    transform: "translate(-1.615 -2)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M3,18.66a7.971,7.971,0,0,1,7.8-8.127H15.2A7.971,7.971,0,0,1,23,18.66a2.491,2.491,0,0,1-2.439,2.54H5.439A2.491,2.491,0,0,1,3,18.66Z",
    transform: "translate(-3 1.657)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFilled);
export default __webpack_public_path__ + "static/media/user-filled.d58e4caf02fb54e717e205ee0c09072c.svg";
export { ForwardRef as ReactComponent };